import { baseInputTheme } from '../BaseInput/theme'

export const selectTheme = {
  ...baseInputTheme,
}
